if (!customElements.get('scrolling-promotion')) {
  class ScrollingPromotion extends HTMLElement {
    constructor() {
      super();

      // Respect “Reduce motion” setting
      if (FoxTheme.config.motionReduced) return;

      this.promotion = this.querySelector('.promotion');
      if (!this.promotion) return;

      FoxTheme.Motion.inView(this, this.init.bind(this), {
        margin: '200px 0px 200px 0px',
      });
    }

    init() {
      // Only set up the marquee once
      if (this.childElementCount === 1) {
        this.promotion.classList.add('promotion--animated');

        // Duplicate the row so it loops seamlessly
        for (let index = 0; index < 10; index++) {
          const clone = this.promotion.cloneNode(true);
          this.appendChild(clone);
        }
      }
    }
  }

  customElements.define('scrolling-promotion', ScrollingPromotion);
}
